var o={name:"rzIconArrow",props:{contrastColor:Boolean,left:Boolean},computed:{modifierClasses:function(){return{"icon-arrow--contrast-color":this.contrastColor,"icon-arrow--left":this.left}}}};export{o as default};
